/** Шаблон захватывает фрагменты `<b>…</b>`, которыми `ts_headline` помечает совпавшие слова */
export const HEADLINE_BOLD_RE = /<b>([\s\S]*?)<\/b>/g;

/** Возвращает текст фрагмента без пометок совпавших слов */
export const stripHeadlineHighlight = (snippet: string): string => snippet.replace(HEADLINE_BOLD_RE, '$1');
